'use strict';

import {throttle, debounce} from './../../../../build/node_modules/@components/throttle-debounce';

const $ = require('jquery');
const Utility = require('./../lib/utilities');
const Breakpoint = require('./../lib/breakpoints');

class StoreLocator {

    constructor() {

        this.$storesMap = $('[data-google-map="salon-overview"]');
        this.keyword = '';
        this.autocompleteCache = {};
        this.searchedBefore = false;

        if (this.$storesMap.length > 0) {

            require('./../lib/google-map');

            const LocationBar = require('./../lib/location-bar');

            this.$searchInput = this.$storesMap.find('[data-google-map-search]');
            this.$markers = this.$storesMap.find('[data-marker]');
            this.markers = this.getAllMarkers();

            //  Init Map
            this.$storesMap.customGoogleMap({
                infoWindow: {
                    show: true,
                    panOnClose: true
                },
                map: {
                    draggable: true
                },
                markers: {
                    data: this.markers
                }
            });

            this.locationBar = new LocationBar();
            this.locationBar.start({
                pushState: true
            });

            //  Init Map Features
            this.resizeResultList();
            this.showInfoWindow();

            /**
             * Update markers on URL change
             */
            this.locationBar.onChange((path) => {

                //  TODO: Maybe later
            });

            this.$storesMap.find('form').on('submit', (event) => {

                event.preventDefault();
            });

            this.$searchInput.on('keyup', debounce(250, (event) => {

                this.keyword = event.target.value.toLowerCase();
                this.$markers.removeClass('hide').css({order: 0});

                //  check if keyword has more than 2 characters
                if (this.keyword.length <= 2) {

                    if (this.searchedBefore) {

                        this.$storesMap.customGoogleMap('filterMarkers', this.markers);

                        let $noResultsBlock = $('.no-salons-found');
                        $noResultsBlock.removeClass('active');
                    }

                    return;
                }

                this.searchedBefore = true;

                App.Globals.$body.addClass('loading');

                //  Ajax handling the input value
                this.getFilteredIds();
            }));

            $('[data-toggle-map]').on('click', (event) => {

                event.preventDefault();

                let $this = $(event.currentTarget);

                if (App.Globals.$body.hasClass('open-map-on-mobile')) {

                    App.Globals.$body.removeClass('open-map-on-mobile');
                    $this.text($this.data('toggle-text-open')).removeClass('minus').addClass('plus');
                } else {

                    App.Globals.$body.addClass('open-map-on-mobile');
                    $this.text($this.data('toggle-text-close')).removeClass('plus').addClass('minus');
                    this.$storesMap.customGoogleMap('filterMarkers', this.markers);
                }
            });
        }
    }

    /**
     * Ajax call to Endpoint. It retrieves and array of IDs of matching salons (from EASE)
     */
    getFilteredIds() {

        let encodedKeyword = encodeURIComponent(this.keyword);
        const cached = this.autocompleteCache[encodedKeyword];

        if (cached) {

            this.renderList(cached);
            this.renderMap(cached);
        } else {

            $.ajax({
                url: `/api/salon_locator/${encodedKeyword}/`,
                dataType: 'json'
            }).done((data) => {

                this.autocompleteCache[encodedKeyword] = data;
                this.renderList(data);
                this.renderMap(data);
            });
        }
    }

    /**
     * Update List
     * @param data
     */
    renderList(data) {

        this.$markers.addClass('hide');

        let $noResultsBlock = $('.no-salons-found');
        $noResultsBlock.removeClass('active');

        if (data.salons.length > 0) {

            //  Update list
            for (let i = 0; i < data.salons.length; i++) {

                //  Show/hide list items based on matching IDs
                let salonId = data.salons[i];
                $(`[data-marker-id="${salonId}"]`).removeClass('hide').css({order: i + 1});
            }
        } else {

            $noResultsBlock.addClass('active');

            setTimeout(() => {
                App.Globals.$body.removeClass('loading');
            }, 1000);
        }
    }

    /**
     * Update Google Maps
     * @param data
     */
    renderMap(data) {

        if (data.salons.length > 0) {

            let filteredMarkers = [];

            for (let i = 0; i < this.markers.length; i++) {

                let markerId = this.markers[i].custom.id;

                if (data.salons.indexOf(markerId) !== -1) {

                    filteredMarkers.push(this.markers[i]);
                }
            }

            this.$storesMap.customGoogleMap('filterMarkers', filteredMarkers);
        } else {

            this.$storesMap.customGoogleMap('resetMap');
        }

        setTimeout(() => {
            App.Globals.$body.removeClass('loading');
        }, 1000);
    }

    /**
     * Changes the height of the salon results list to match the map area
     */
    resizeResultList() {

        App.Globals.$window
            .on('ready resize', throttle(200, () => {
                this.setHeights()
            }));

        this.setHeights()
    }

    setHeights() {
        let $searchBlock = $('.salon-search');
        let $salonList = $('.salon-list');
        let $mapHolder = $('[data-google-map-holder]');

        if (Breakpoint.atLeast('large')) {

            let searchBlockHeight = $searchBlock.outerHeight();
            let mapHolderHeight = $mapHolder.height();

            $salonList.css({
                'height': (mapHolderHeight - searchBlockHeight),
                'margin-top': searchBlockHeight
            });
        } else {

            $salonList.css({
                'height': 'auto',
                'margin-top': 0
            });
        }
    }

    /**
     * Get All markers from the HTML [data-marker]
     * @return {Array}
     */
    getAllMarkers() {

        let markers = [];

        if (this.$markers.length > 0) {

            this.$markers.each(function () {

                let $this = $(this);
                let defaultIcon = rk_globals.theme_path + '/dist/' + rk_globals.current_site +'/img/marker.svg';

                //  Create a Marker
                markers.push({
                    custom: {
                        id: $this.data('marker-id')
                    },
                    position: {
                        lat: parseFloat($this.data('marker-lat')),
                        lng: parseFloat($this.data('marker-lng'))
                    },
                    icon: {
                        default: {
                            url: defaultIcon,
                            size: {
                                height: 48,
                                width: 48
                            }
                        },
                        active: {
                            url: defaultIcon,
                            size: {
                                height: 48,
                                width: 48
                            }
                        }
                    },
                    infoWindow: $this.find('[data-marker-info-window]').html()
                });
            });

        }

        return markers;
    }

    showInfoWindow() {

        this.$storesMap.on('map:infowindow:open:id', (event, markerId) => {

            let $target = $(`[data-marker-id="${markerId}"]`);

            if ($target.length > 0) {

                // let targetTop = $target.position().top;
                let html = $target.find('[data-marker-info-window]').html();

                //  Adds HTML to Marker
                this.$storesMap.customGoogleMap('showInfoWindow', markerId, html);
            }
        });
    }

}

module.exports = StoreLocator;
